import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { AppSmart } from './App';
import './index.css';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { SnackbarProvider, closeSnackbar } from 'notistack';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { defaultTheme } from './themes';
import { DialogHost } from './services/ui-dialog';


const container = document.getElementById('root');
if (!container) throw new Error('Root container missing');
const root = createRoot(container);
root.render(
  <SnackbarProvider
    maxSnack={3}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    action={(snackbarId) => (
      <IconButton
        onClick={() => closeSnackbar(snackbarId)}
        size="small"
        aria-label="Dismiss notification"
        sx={{ color: 'inherit', opacity: 0.85, '&:hover': { opacity: 1 } }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    )}
    style={{
      maxWidth: 480,
    }}
  >
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={defaultTheme}>
        <AppSmart />
        <DialogHost />
      </ThemeProvider>
    </StyledEngineProvider>
  </SnackbarProvider>
);
